import { render } from "./ClientTradesView.vue?vue&type=template&id=ad51aa98&scoped=true"
import script from "./ClientTradesView.vue?vue&type=script&lang=js"
export * from "./ClientTradesView.vue?vue&type=script&lang=js"

import "./ClientTradesView.vue?vue&type=style&index=0&id=ad51aa98&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad51aa98"]])

export default __exports__